import React, { useCallback, useState } from "react";
import formatCurrency from "@tvg/formatter/currency";
import { Icon, Paragraph } from "@tvg/design-system";
import { Button, Container, ButtonContent } from "./styled-components";

import Dropdown from "../Dropdown";

export interface BetAmountSelectorProps {
  selectedAmount: string;
  onSelect: (value: string) => void;
  values: Array<string>;
  isDropdownVisible?: boolean;
}

const BetAmountSelector = ({
  onSelect,
  values,
  selectedAmount,
  isDropdownVisible = false
}: BetAmountSelectorProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(isDropdownVisible);

  const onSelectValue = useCallback((value) => {
    setIsDropdownOpen(false);
    onSelect(value);
  }, []);

  const onClick = useCallback(() => {
    setIsDropdownOpen((prevState) => !prevState);
  }, []);

  return (
    <Container>
      <Button onClick={onClick} data-qa-label="bet-slip-amount-selector-button">
        <ButtonContent data-qa-label="bet-slip-amount-selector-button-content">
          <Paragraph
            fontFamily="bold"
            fontSize="s"
            color="grey.900"
            qaLabel="bet-slip-amount-selector-text"
          >
            {formatCurrency(selectedAmount)}
          </Paragraph>
          <Icon
            ml="auto"
            name={isDropdownOpen ? "chevronUp" : "chevronDown"}
            size="s"
            lineColor="blue_accent.500"
          />
        </ButtonContent>
      </Button>
      <Dropdown
        isVisible={isDropdownOpen}
        values={values}
        selectedValue={selectedAmount}
        onSelectValue={(value) => onSelectValue(value)}
        onClickAway={() => setIsDropdownOpen(false)}
      />
    </Container>
  );
};

export default BetAmountSelector;
